import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError, safeNext } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/Loader";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        const next = safeNext(sessionStorage.getItem("lorely_next"));
        sessionStorage.removeItem("lorely_next");
        nav(next || "/worlds", { replace: true });
      })
      .catch((e) => {
        toast.error(formatApiError(e));
        setUser(false);
        nav("/login", { replace: true });
      });
  }, [location.hash, nav, setUser]);

  return <Loader label="Opening the gates..." />;
}
